import { default as api } from 'config/authApiConf.js';

export const logoDetailService = async (id = null) => {
	try {
		let result = await api.get(`/cms/logo-details/${id}`);
		return result;
	} catch (error) {
		return error;
	}
};

export const logoEditService = async (id = null, data = {}) => {
	try {
		let result = await api.put(`/cms/edit-logo/${id}`, data);
		return result;
	} catch (error) {
		return error;
	}
};
